export const normalizeWhenNegative = (luxonDuration) =>
  luxonDuration.valueOf() < 0 ? luxonDuration.negate() : luxonDuration;

export const getFormatedTimer = (luxonDate, format = "hh:mm:ss") => {
  const duration = luxonDate.diffNow(["minutes", "seconds", "milliseconds"]);

  return normalizeWhenNegative(duration).toFormat(format);
};
